import { Typography, Stack, Grid, Box } from "@material-ui/core";
import { Trans, useTranslation } from "react-i18next";

// NOTE: BE CAREFULL, this will be on the Discount page as well!!!
export default function Content() {
  const { t } = useTranslation();

  return (
    <>
      <Stack gap={3} sx={{ py: 2 }}>
        {/* Title & Dates */}
        <Stack alignItems="center" gap={1}>
          <Typography
            variant="h3"
            fontWeight="bold"
            textAlign="center"
            color="primary"
            sx={{ letterSpacing: "0.5px", mb: 3 }}
          >
            {t("dialogTitle")}
          </Typography>
          <Typography
            variant="h4"
            fontWeight="bold"
            fontStyle="italic"
            textAlign="center"
            color="text.primary"
          >
            {t("dialogSubtitle")}
          </Typography>
        </Stack>

        {/* Main Discounts */}
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            lineHeight: 1.6,
            fontWeight: 500,
            px: { xs: 2, md: 4 },
          }}
        >
          <Trans i18nKey="dialogContent1" />
        </Typography>

        {/* Price Details */}
        {/* <Stack
          alignItems="stretch"
          gap={1.5}
          sx={{
            my: 1,
            p: { xs: 2, sm: 3 },
            backgroundColor: "background.paper",
            borderRadius: 2,
            borderLeft: "4px solid #95436c",
            width: "100%",
            maxWidth: "600px",
            mx: "auto",
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            color="primary"
            textAlign="center"
            sx={{ mb: 1 }}
          >
            {t("dialogContent2")}
          </Typography>

          <Box sx={{ width: "100%" }}>
            {[
              {
                labelKey: "dialogPrice5Label",
                originalKey: "dialogPrice5Original",
                discountedKey: "dialogPrice5Discounted",
              },
              {
                labelKey: "dialogPrice30Label",
                originalKey: "dialogPrice30Original",
                discountedKey: "dialogPrice30Discounted",
              },
              {
                labelKey: "dialogPriceHalfLabel",
                originalKey: "dialogPriceHalfOriginal",
                discountedKey: "dialogPriceHalfDiscounted",
              },
              {
                labelKey: "dialogPriceYearLabel",
                originalKey: "dialogPriceYearOriginal",
                discountedKey: "dialogPriceYearDiscounted",
              },
            ].map((row, idx) => (
              <Grid
                container
                key={idx}
                spacing={1}
                sx={{
                  py: 1.25,
                  borderBottom: idx < 3 ? "1px solid rgba(0,0,0,0.06)" : "none",
                  alignItems: "center",
                }}
              >
                <Grid item xs={12} sm={6}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      textAlign: { xs: "center", sm: "left" },
                    }}
                  >
                    {t(row.labelKey)}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      textAlign: { xs: "right", sm: "left" },
                      textDecoration: "line-through",
                    }}
                  >
                    {t("dialogPriceInsteadOf", { price: t(row.originalKey) })}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography
                    variant="body1"
                    color="primary"
                    sx={{
                      fontWeight: "bold",
                      textAlign: { xs: "left", sm: "right" },
                      pl: { xs: 2, sm: 0 },
                      fontSize: "1.1rem",
                    }}
                  >
                    {t(row.discountedKey)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Stack> */}

        {/* Disclaimer */}
        <Typography
          variant="body2"
          fontStyle="italic"
          textAlign="center"
          color="text.secondary"
          sx={{
            px: { xs: 1, md: 3 },
            lineHeight: 1.5,
          }}
        >
          {t("dialogContent4")}
        </Typography>
      </Stack>
    </>
  );
}
